import groupedRequestDetailsStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_DATA_READY', function setIsDataReadyInStore(isDataReady: boolean) {
    if (groupedRequestDetailsStore) {
        groupedRequestDetailsStore.isDataReady = isDataReady;
    }
});
